import React, { useState, useEffect } from 'react';
import { FiUpload } from 'react-icons/fi';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';

const FormEditDocumentTemplate = ({ isOpen, onClose, title, selectTemplate, onSubmit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    tipo: 'Documento Word',
    arquivo: '',
    arquivoObj: null
  });

  const [selectedFileName, setSelectedFileName] = useState('Nenhum arquivo escolhido');
  
  const tipoOptions = [
    { value: 'Documento Word', label: 'Documento Word' },
    { value: 'Apresentação PowerPoint', label: 'Apresentação PowerPoint' },
  ];
  
  useEffect(() => {
    if (selectTemplate) {
      setFormData({
        id: selectTemplate.id || null,
        nome: selectTemplate.nome || '',
        tipo: selectTemplate.tipo || 'Documento Word',
        arquivo: selectTemplate.arquivo || '',
        arquivoObj: null
      });
      setSelectedFileName(selectTemplate.arquivo || 'Nenhum arquivo escolhido');
    } else {
      setFormData({
        nome: '',
        tipo: 'Documento Word',
        arquivo: '',
        arquivoObj: null
      });
      setSelectedFileName('Nenhum arquivo escolhido');
    }
  }, [selectTemplate]);

  const handleChange = (eOrValue, fieldName) => {
    if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: eOrValue.value,
      }));
    } else {
      const { name, value } = eOrValue.target;
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFormData(prev => ({
        ...prev,
        arquivo: file.name,
        arquivoObj: file
      }));
      setSelectedFileName(file.name);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      const { arquivoObj, ...dataToSubmit } = formData;
      onSubmit(dataToSubmit);
    }
  };

  const renderFormFields = () => {
    return (
      <div>
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Nome:'
            name='nome'
            placeholder="Informe o nome do template"
            value={formData.nome}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className='pb-4'>
          <Select
            label='Tipo:'
            placeholder="Selecione o tipo"
            name='tipo'
            options={tipoOptions}
            value={formData.tipo}
            onChange={(option) => handleChange(option, 'tipo')}
            className="mt-2"
          />
        </div>
        
        <div className='pb-4'>
          <label className="block font-medium mb-2">Anexo:</label>
          <div className="flex">
            <label className="cursor-pointer bg-gray-100 px-4 py-2 border border-gray-300 rounded-l-md hover:bg-gray-200 transition-colors flex items-center justify-center">
              <FiUpload className="text-gray-600" />
              <input
                type="file"
                className="hidden"
                onChange={handleFileChange}
                accept=".doc,.docx,.pdf,.txt,.ppt,.pptx,.xls,.xlsx"
              />
            </label>
            <div className="flex-1 px-3 py-2 bg-white border border-l-0 border-gray-300 rounded-r-md text-gray-500 truncate">
              {selectedFileName}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title || "Criar Template de Documento"}
      submitText="Salvar"
      className='max-w-4xl'
    >
      {renderFormFields()}
    </BaseForm>
  );
};

export default FormEditDocumentTemplate;